import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Validation/ValidationMessage.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "div";
var VALIDATION_MESSAGE_CLASSNAME_MAP = {
  variant: {
    success: "pd:text-success-600",
    info: "pd:text-info-600",
    warning: "pd:text-warning-600",
    error: "pd:text-error-600",
    dim: "pd:text-dim-800"
  }
};
var ValidationMessage = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      variant = "info",
      className
    } = _b,
    rest = __objRest(_b, ["as", "children", "variant", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  return /* @__PURE__ */jsx(Component, __spreadProps(__spreadValues({
    ref,
    className: clsx("pd:validation-message", VALIDATION_MESSAGE_CLASSNAME_MAP.variant[variant], className)
  }, rest), {
    children
  }));
});
var ValidationMessage_default = ValidationMessage;
export { VALIDATION_MESSAGE_CLASSNAME_MAP, ValidationMessage_default };